import type { NodePropertySchema } from '../../../types/node-properties';

const schema: NodePropertySchema = {
  nodeType: 'linear',
  version: '1.2.0',
  properties: [
    // Properties will be defined based on n8n equivalents
  ]
};

export default schema;
